import PropTypes from 'prop-types';

export const ParticipantType = {
    id: PropTypes.number,
    name: PropTypes.string,
    image: PropTypes.string,
    type: PropTypes.string
};
